import { schema } from 'normalizr';
import { createAction } from 'redux-actions';
import apiResourceBuilder from '../../../../common/utils/apiResourceBuilder';
import entityActionCreator from '../../../../common/utils/entityActionCreator';
import { lookUpActionReducer } from '../legislators';

export const surveysApi = apiResourceBuilder('emts/surveys');

export const surveySchema = new schema.Entity(
  'surveys',
  {},
  { idAttribute: 'key' }
);

export const SurveyActionTypes = {
  CLEAR: 'ENTITY/ENTITY_CLEAR',
};

const reducerActions = {
  [SurveyActionTypes.CLEAR]: () => ({}),
};

export const surveysReducer = lookUpActionReducer(reducerActions);

export default {
  ...entityActionCreator({ schema: surveySchema, api: surveysApi }),
  clear: createAction(SurveyActionTypes.CLEAR),
};



// WEBPACK FOOTER //
// ./src/App/account/actions/surveys/index.js